import { Field, FieldAttributes, useFormikContext } from 'formik';
import React from 'react';

import { TraitSelect } from 'dashboard/pages/Segment/components/Rule/UserPropertyRule/TraitSelect';

import { FilterEnglishNames, UserPropertyFilter } from './types';

const filterTypes = Object.entries(FilterEnglishNames).map(([key, value]) => ({
  value: key,
  label: value,
}));

export const TraitSelector = () => {
  const { values, setFieldValue } = useFormikContext<UserPropertyFilter>();

  return (
    <Field name="traitName">
      {({ field }: FieldAttributes<any>) => (
        <TraitSelect
          {...field}
          selectedItem={filterTypes.find((i) => i.value === values.type)}
          clearable={false}
          handleChange={(item: any) => {
            setFieldValue('traitName', item.name, false);
          }}
        />
      )}
    </Field>
  );
};
